module.exports = __webpack_public_path__ + "static/easiest-setup-6e2d63e3643ef303edfd6c8a67f85aab.svg";